
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/es-mx/contacto",
      function () {
        return require("private-next-pages/es-mx/contacto/index.js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/es-mx/contacto"])
      });
    }
  